/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navbar_Nav_FeaturesInputs */

const es_navbar_nav_features = /** @type {(inputs: Navbar_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

const en_navbar_nav_features = /** @type {(inputs: Navbar_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Navbar_Nav_FeaturesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const navbar_nav_features = /** @type {((inputs?: Navbar_Nav_FeaturesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navbar_Nav_FeaturesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_navbar_nav_features(inputs)
	return en_navbar_nav_features(inputs)
});
export { navbar_nav_features as "navbar.nav_features" }